// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./SpaceSciencesImages/portalBackground.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceSciencesPortalBackground
{
    width: 100%;
    height:600px;
    display: flex;
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover; 
    position: relative;

}

@media only screen and (max-width: 1000px)
{
    .SpaceSciencesPortalBackground{

        height: auto;
        width: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/SpaceSciencePortal/SpaceSciencesCourseDetails.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oDAA8D;IAC9D,sBAAsB;IACtB,kBAAkB;;AAEtB;;AAEA;;IAEI;;QAEI,YAAY;QACZ,WAAW;IACf;AACJ","sourcesContent":[".SpaceSciencesPortalBackground\n{\n    width: 100%;\n    height:600px;\n    display: flex;\n    background:  url('./SpaceSciencesImages/portalBackground.png');\n    background-size: cover; \n    position: relative;\n\n}\n\n@media only screen and (max-width: 1000px)\n{\n    .SpaceSciencesPortalBackground{\n\n        height: auto;\n        width: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
